import {ApexOptions} from "apexcharts";
import {useEffect, useState} from "react";

import dynamic from "next/dynamic";
const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});
interface ChartSeries {
  name: string;
  data: number[];
}
type trends = {
  date: number;
  runningTime: number;
}[];
export function NokiaTimeDrivenChart({charttrends}: {charttrends: trends}) {
  const [drivenChartOption, setdrivenChartOption] = useState<{
    options: ApexOptions;
    series: ChartSeries[];
  }>({
    options: {
      chart: {
        type: "area",
        height: 120,
        // toolbar: {show: false},
        zoom: {
          enabled: true
          // type: "xy",
          // autoScaleYaxis: true
        }
        //background: isDarkMode ? "#000000" : "#ffffff"
      },

      xaxis: {
        // categories: paginatedCategories,
        labels: {
          show: true,
          style: {
            fontSize: "10px",
            colors: "#64748B"
          }
        }
      },
      yaxis: {
        labels: {
          formatter: (val: number) => `${val} h`,
          style: {
            colors: "#64748B"
          }
        }
      },
      dataLabels: {enabled: false},
      stroke: {
        curve: "straight"
      },
      labels: []
      // legend: {
      //   position: "top",
      //   horizontalAlign: "right",
      //   show: false
      // },
      // grid: {
      //   padding: {left: 0, right: 0, top: 10, bottom: 0}
      //   //borderColor: isDarkMode ? "#334155" : "#e2e8f0"
      // },
      // colors: ["#22c55e", "#f97316"]
    },
    series: [
      // {name: "Scheduled", data: [10, 20]},
      //{name: "UnScheduled", data: []}
    ]
  });
  useEffect(() => {
    let runningTime: any = [];
    let dateLabel: any = [];
    if (charttrends.length > 0) {
      runningTime = charttrends.map(ele => ele.runningTime);
    }

    if (charttrends.length > 0) {
      dateLabel = charttrends.map(dat => dat.date);
    }
    let datee: any = new Date(dateLabel);
    //

    setdrivenChartOption(prev => ({
      ...prev,
      options: {
        ...prev.options,
        labels: datee
      },
      series: [{name: "UnScheduled", data: runningTime}]
    }));
  }, [charttrends]);
  return (
    <div>
      <Chart
        options={drivenChartOption.options}
        series={drivenChartOption.series}
        type="area"
        height={150}
      />
    </div>
  );
}
